<template>
  <Card class="">
    <template #title>
      <b>Hızlı İşlemler</b>
    </template>
    <template #content>
      <div class="grid flex flex-wrap align-items-center justify-content-center">

        <div class="w-min md:w-max col-12 md-6 lg-2 flex flex-wrap align-items-center justify-content-center">
          <Button label="Urun Giriş" icon="pi pi-sign-in" iconPos="top" class="button-lg hizli-btn"
            severity="success" rounded raised @click="BtnClick('UrunGiris')" />
        </div>

        <div class="w-min md:w-max col-12 md-6 lg-2 flex flex-wrap align-items-center justify-content-center">
          <Button label="Urun Transfer" icon="pi pi-sync" iconPos="top" class="button-lg hizli-btn" severity="help" rounded
            raised @click="BtnClick('UrunTransfer')"/>
        </div>

        <div class="w-min md:w-max col-12 md-6 lg-2 flex flex-wrap align-items-center justify-content-center">
          <Button label="Urun Satış" icon="pi pi-sign-out" iconPos="top" class="button-lg hizli-btn"
            severity="danger" rounded raised @click="BtnClick('UrunSatis')" />
        </div>

        <div class="w-min md:w-max col-12 md-6 lg-2 flex flex-wrap align-items-center justify-content-center">
          <Button label="Urun" icon="pi pi-sign-in" iconPos="top" class="button-lg hizli-btn" severity="info" rounded
            raised @click="BtnClick('UrunListesi')" />
        </div>

        <div class="w-min md:w-max col-12 md-6 lg-2 flex flex-wrap align-items-center justify-content-center">
          <Button label="Blank" icon="pi pi-sign-in" iconPos="top" class="button-lg hizli-btn" severity="help" rounded
            raised />
        </div>

        <div class="w-min md:w-max col-12 md-12 lg-2 flex flex-wrap align-items-center justify-content-center">
          <Button label="Blank" icon="pi pi-sign-in" iconPos="top" class="button-lg hizli-btn" severity="warn" rounded
            raised />

        </div>
      </div>
    </template>
  </Card>

</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    BtnClick(Nereye) {
      switch (Nereye) {
        case "UrunGiris":
          this.$router.push({ path: "/Islemler/UrunGiris" });
          break;
        case "UrunTransfer":
          this.$router.push({ path: "/Islemler/UrunTransfer" });
          break;
        case "UrunSatis":
          this.$router.push({ path: "/Islemler/UrunSatis" });
          break;
        case "UrunListesi":
          this.$router.push({ path: "/Urun/UrunListesi" });
          break;


        case "":
          break;

        default:
          break;
      }
    }
  },
  mounted() {
  },
  components: {
  },
};
</script>

<style></style>